import { createRouter, createWebHistory } from "vue-router";
import { routes } from "./routes";
import { setupRouteEffects } from "./setupRouteEffects";
import { installRouteLoadingSpinner } from "./loading.guard";

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition ?? { left: 0, top: 0 };
  },
});

installRouteLoadingSpinner(router);

setupRouteEffects(router);

export default router;
